import { TableRow, TableCell } from '@mui/material';

const TypesRowsComponent = ({ rows }) => {
  return rows?.map((row) => (
    <TableRow
      key={row.id}
      sx={{
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }}
    >
      <TableCell>{row.mx_month}</TableCell>
      <TableCell>{row.producto}</TableCell>
      <TableCell>{row.sku}</TableCell>
      <TableCell>{row.q}</TableCell>

      <TableCell>{row.minutes}</TableCell>
      <TableCell>{row.minutes_altan}</TableCell>
      <TableCell>{row.minutes_roaming}</TableCell>
      <TableCell>{row.total_min_con_altan}</TableCell>

      <TableCell>{row.sms}</TableCell>
      <TableCell>{row.sms_altan}</TableCell>
      <TableCell>{row.sms_roaming}</TableCell>
      <TableCell>{row.total_sms}</TableCell>
      <TableCell>{row.total_sms_con_altan}</TableCell>

      <TableCell>{row.mobile_data}</TableCell>
      <TableCell>{row.mobile_data_roaming}</TableCell>
      <TableCell>{row.total_mobile_data}</TableCell>

      <TableCell>{row.social_network_data}</TableCell>
      <TableCell>{row.social_network_data_roaming}</TableCell>
      <TableCell>{row.social_network_data_throttling}</TableCell>
      <TableCell>{row.throttling_data}</TableCell>
      <TableCell>{row.total_mb_redes_sociales}</TableCell>
      <TableCell>{row.total_gb_redes}</TableCell>

      <TableCell>{row.total_datos_gb}</TableCell>
    </TableRow>
  ));
};

export default TypesRowsComponent;
